import React from 'react'
import IconBase from 'components/atoms/IconBase/IconBase'

interface Props {
  className?: string
}

function Minus({ className }: Props) {
  return (
    <IconBase name="minus" w={20} className={className}>
      <path d="M16.7699 10.0933H4.91665" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </IconBase>
  )
}

export default Minus
